import { AfterViewInit, Component, ElementRef, OnInit, Optional, Type, ViewChild } from '@angular/core';
import { HomeInputGridComponent } from '../home-input-grid/home-input-grid.component';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { BannerLayoutClasses, RendererType } from '@urbannex/storethemes';
import { BannerInputDialogComponent } from './banner-input-dialog/banner-input-dialog.component';

@Component({
  selector: 'kve-home-input-banner',
  templateUrl: './home-input-banner.component.html',
  styleUrls: ['./home-input-banner.component.scss']
})
export class HomeInputBannerComponent implements OnInit, AfterViewInit {
  activeInputMenuItem: string;
  title: string;
  collapsed: boolean = true;
  isCreate = true;
  // BannerInputDialogComponent

  @ViewChild('expandable', { read: ElementRef }) expandable: ElementRef<HTMLElement>
  constructor(
    private el: ElementRef<HTMLElement>,
    @Optional() protected ref: NbDialogRef<BannerInputDialogComponent>,
    private dialogService: NbDialogService) { }

  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    const overlayPane = this.el.nativeElement.parentElement.parentElement;
    const overlayWrapper = this.el.nativeElement.parentElement.parentElement.parentElement;
    setTimeout(() => {
      overlayWrapper.style.left = "0px";
      overlayWrapper.style.justifyContent = "flex-end";
      overlayWrapper.style.right = "16px";
      // overlayPane.style.width = "256px";
      overlayPane.style.marginRight = "16px";
      overlayPane.style.marginTop = "58px";
      overlayPane.style.display = "block";
    }, 1);


    // return el.parentElement.parentElement.parentElement.parentElement;
  }

  toggleContainer() {
    this.expandable.nativeElement.classList.toggle("collapsed");
    this.collapsed != this.collapsed;
  }

  close() {
    this.ref.close();
  }
  /**
   * LAYOUT_1 = "layout-class-1",
    LAYOUT_2 = "layout-class-2",
    LAYOUT_3 = "layout-class-3",
    LAYOUT_4 = "layout-class-4",
    LAYOUT_5 = "layout-class-5",
    LAYOUT_6 = "layout-class-6",
    LAYOUT_7 = "layout-class-6"
   * @param e
   */
  createBanner(e) {
    console.log(e);
    const component: Type<any> = BannerInputDialogComponent;
    const layoutClass = e
    BannerLayoutClasses.LAYOUT_1
    this.dialogService.open(component, {
      context: {
        rendererType: RendererType.BANNER,
        layoutClass: layoutClass,
        title: "Adding new section with banner layout"
      }
    }).onClose.subscribe(() => {
      console.log("closing")
    })
    this.ref.close();
  }
  /* createGrid(numberOfCells:number){
    let component:Type<any> = GridInputDialogComponent;
    let layoutClass = "grid-"+numberOfCells;

    console.log(layoutClass)


  } */

}
